import axios from 'axios';
import { API_URL } from '../config/api';

class PasswordResetService {
  private api = axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  /**
   * Request password reset email
   */
  async forgotPassword(email: string): Promise<{ message: string }> {
    try {
      const response = await this.api.post(`/forgot-password?email=${encodeURIComponent(email)}`);
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.detail || 'Error al solicitar restablecimiento de contraseña'
      );
    }
  }

  /**
   * Reset password with token
   */
  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    try {
      const response = await this.api.post(`/reset-password/${token}`, newPassword, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error: any) {
      throw new Error(
        error.response?.data?.detail || 'Error al restablecer contraseña'
      );
    }
  }
}

// Export singleton instance
const passwordResetService = new PasswordResetService();
export default passwordResetService;
